import React, { useState } from "react";
import { Button, Modal, Radio, Select } from "antd";
import { axiosInstance } from "/src/api/apiModule";
import { message } from "/src/components/UI/AntdAppHelper";
import { showConfirmModal } from "/src/components/UI/Segment/UIHelper";
import "./MbProvisioningModal.scss";

const { Option } = Select;

const MbProvisioningModal = (props) => {
  const { item } = props;
  const [isMBProvisioningModalVisible, setIsMBProvisioningModalVisible] = useState(false);
  const [selectedMbStatus, setSelectedMbStatus] = useState("enabled");
  const [selectedPrograms, setSelectedPrograms] = useState(["all"]);

  const handleMbModalOk = () => {
    const orgId = item?.id;

    //If All is selected in select Programs, we need to send value as string "all" otherwise we are sending array of selected programs
    const programmeCodes = selectedPrograms.length > 0 && !selectedPrograms.includes("all") ? selectedPrograms : "all";

    showConfirmModal({
      title: "Confirm MB Provisioning Change",
      content: `Are you sure you want to ${
        selectedMbStatus === "enabled" ? "enable" : "disable"
      } MB Provisioning for the selected programs?`,
      okText: "Yes, Apply Changes",
      cancelText: "Cancel",
      okType: "primary",
      onOk: () => {
        applyMbProvisioningChanges(orgId, selectedMbStatus, programmeCodes);
      },
    });
  };

  const applyMbProvisioningChanges = (orgId, status, programmeCodes) => {
    const mbStatusData = {
      status: status,
      programme_codes: programmeCodes,
    };

    const url = `orgs/${orgId}/update_mb_status`;

    axiosInstance.instance
      .post(url, mbStatusData)
      .then((response) => {
        message.success(`MB Provisioning ${selectedMbStatus} successfully!`);
        handleMbModalCancel();
      })
      .catch((error) => {
        console.error("MB status update error:", error);
        const actionText = selectedMbStatus === "enabled" ? "enable" : "disable";
        message.error(`Failed to ${actionText} MB Provisioning`);
      });
  };

  const handleMbModalCancel = () => {
    setSelectedMbStatus("enabled");
    setSelectedPrograms(['all']);
    setIsMBProvisioningModalVisible(false);
  };

  const handleMbOptionChange = (e) => {
    setSelectedMbStatus(e.target.value);
  };
  
  const handleProgramChange = (selectedValues) => {
    if (selectedValues.includes("all")) {
      if(selectedPrograms.includes("all")) {
        const filtered = selectedValues.filter((value) => value !== "all");
        setSelectedPrograms(filtered);
      } else {
        setSelectedPrograms(["all"]);
      }
    } else {
      // When we remove all programs, then we have to set all in selectedPrograms
      if(selectedValues.length > 0) {
        setSelectedPrograms(selectedValues);
      } else {
        setSelectedPrograms(["all"]);
      }
    }
  };

  return (
    <>
      <Button 
        key="mb-provisioning-btn" 
        onClick={() => setIsMBProvisioningModalVisible(true)}
      >
        MB Provisioning
      </Button>
      <Modal
        title="Manage MB Provisioning"
        width={1000}
        open={isMBProvisioningModalVisible}
        onOk={handleMbModalOk}
        onCancel={handleMbModalCancel}
        okText="Apply"
        cancelText="Cancel"
      >
      <div className="mb-provisioning-modal-wrapper">
        <p>Select Enable or Disable MB Provisioning</p>
        <Radio.Group
          value={selectedMbStatus}
          onChange={handleMbOptionChange}
          className="mb-provisioning-radio-group m-b-20"
        >
          <Radio value="enabled">Enable </Radio>
          <Radio value="disabled">Disable </Radio>
        </Radio.Group>

        <div>
          <h4>Select Programs:</h4>
          <Select
            mode="multiple"
            placeholder="Select programs"
            value={selectedPrograms}
            onChange={handleProgramChange}
            className="mb-provisioning-select"
            size="large"
            showSearch
          >
            <Option key="select-all" value="all">
              Select All
            </Option>
            {item?.org_programmes &&
              item.org_programmes.map((program) => {
                if (program.archived) return null;
                return (
                  <Option
                    key={`program-${program.id}`}
                    value={program.code}
                  >
                    {program.name}
                  </Option>
                );
              })}
          </Select>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default MbProvisioningModal;
